import { AxiosResponse } from 'axios';

import { PlaidLinkTokenData, PlaidLinkTokenParams } from './usePlaidLinkToken.interface';

import collectiveApi from 'modules/common/collectiveApi';

const createPlaidLinkToken = async (params: PlaidLinkTokenParams): Promise<PlaidLinkTokenData> => {
    const { data } = await collectiveApi.post<
        PlaidLinkTokenData,
        AxiosResponse<PlaidLinkTokenData>,
        PlaidLinkTokenParams
    >('plaid/link-token/new/', params);

    return data;
};

export default createPlaidLinkToken;
